<template>
    <div>
        <page-header :buttons="buttons" :additional="[]" @method="methodHandler">
            <template slot="title">Sms Credits</template>
        </page-header>
        <Spinner v-if="loading" />
        <div v-if="!loading" class="lg:px-6 px-4 pt-2">
            <input-text
                v-model="credits"
                label="Update credits"
                name="name"
                placeholder="Enter a number"
                :initial-value="credits"
                rules="required"
            />
        </div>
    </div>
</template>

<script>
    import axios from "axios";

    export default {
        name: "SmsCredits",
        data: function() {
            return {
                loading: true,
                credits: 0,
                buttons: [{
                    label: 'Save',
                    icon: 'save',
                    iconClass: 'text-green-600',
                    type: 'method',
                    method: 'save',
                }]
            }
        },
        methods: {
            methodHandler: function(method){
                this[method]();
            },
            save: function () {
                this.loading = true

                axios.put(process.env.VUE_APP_API_URL + '/sms-credits', {
                    credits: this.credits
                })
                    .then(response => {
                        this.$notify({
                            group: 'main',
                            type: 'success',
                            title: 'Success',
                            text: 'Credits updated',
                            duration: 5000
                        });
                    })
                    .catch(error => {
                        console.error(error)
                        this.$notify({
                            group: 'main',
                            position: 'bottom right',
                            type: 'error',
                            title: 'Error',
                            text: 'Error updating credits',
                            duration: 5000
                        });
                    })
                    .finally(() => {
                        this.loading = false
                    })
            }
        },
        mounted() {
            axios.get(process.env.VUE_APP_API_URL + '/sms-credits')
                .then(response => {
                    this.credits = response.data.data.credits
                    this.loading = false
                })
        },
    }
</script>

<style scoped>

</style>
